import LegalLayout, { Section } from "@/components/site/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      eyebrow="Terms"
      title="Terms of Use"
      updated="December 2025"
      seo={{
        title: "Terms of Use | Xadentra",
        description: "Terms governing your use of the Xadentra website and content.",
        path: "/terms",
      }}
    >
      <p className="text-base text-[#07111F]">
        These Terms of Use ("Terms") govern your access to and use of the Xadentra website and the
        content we publish. By using the site, you agree to these Terms.
      </p>

      <Section title="1. Use of the site">
        <p>You agree to use the site for lawful purposes only and in a way that does not infringe any rights of, or restrict the use and enjoyment of, this site by any third party.</p>
      </Section>

      <Section title="2. Intellectual property">
        <p>Unless otherwise stated, Xadentra or its licensors owns the intellectual property rights for all material on the site. You may view and print pages for personal or internal business use, but you may not republish, sell, rent, or reproduce content without written permission.</p>
      </Section>

      <Section title="3. Third-party trademarks">
        <p>Adobe Marketo Engage and Salesforce are trademarks of their respective owners. Xadentra is not affiliated with or endorsed by these companies unless otherwise stated in writing.</p>
      </Section>

      <Section title="4. No warranty">
        <p>The website and content are provided "as is" without warranties of any kind. Xadentra does not warrant that the site will be uninterrupted, error-free, or free of viruses or other harmful components.</p>
      </Section>

      <Section title="5. Limitation of liability">
        <p>To the maximum extent permitted by law, Xadentra is not liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the site.</p>
      </Section>

      <Section title="6. Links to other sites">
        <p>The site may contain links to third-party websites that are not under our control. We are not responsible for the content or policies of those sites.</p>
      </Section>

      <Section title="7. Changes">
        <p>We may update these Terms from time to time. Continued use after changes are posted constitutes acceptance of the revised Terms.</p>
      </Section>

      <Section title="8. Governing law">
        <p>These Terms are governed by the laws of the jurisdiction in which Xadentra Inc. is registered, without regard to conflict-of-law principles.</p>
      </Section>

      <Section title="9. Contact">
        <p>Questions about these Terms can be sent to <a href={"mail" + "to:" + "contact" + "@" + "xadentra.com"} className="text-[#6D4DFF] underline">{"contact" + "@" + "xadentra.com"}</a>.</p>
      </Section>
    </LegalLayout>
  );
}
